<template>
	<component
		:is="as || 'div'"
		class="rounded-xl"
		:class="{
			'bg-fill-secondary': alt,
			'bg-fill-tertiary': !alt
		}"
	>
		<slot />
	</component>
</template>
<script setup lang="ts">
defineProps<{
	alt?: boolean
	as?: string
}>()
</script>
